import { SessionRealtimeChannelsModel } from "@/models";

export type SessionRealtimeChannelKey = keyof SessionRealtimeChannelsModel;

// Single source of truth for realtime channel keys, tied to BE schema
export const REALTIME_CHANNEL = {
  MAIN: "main",
  TEACHER_HELPER: "teacherHelper",
  TEACHER_ONE_ONE: "oneOne",
  HELPER_ONE_ONE: "helperOneOne",
} as const satisfies Record<string, SessionRealtimeChannelKey>;

export const DEFAULT_SESSION_CHANNEL_KEY: SessionRealtimeChannelKey = REALTIME_CHANNEL.MAIN;

export const resolveChannelName = (
  requestedChannel: SessionRealtimeChannelKey = DEFAULT_SESSION_CHANNEL_KEY,
  channels?: SessionRealtimeChannelsModel | null,
): string | undefined => {
  if (!channels) {
    return undefined;
  }

  return channels[requestedChannel] ?? channels[DEFAULT_SESSION_CHANNEL_KEY];
};
